import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ToolbarMode } from '@fuse/types/fuse-config';
import { PortalEventsComponent } from './portal-events.component';
import { EventsArchiveComponent } from './events-archive/events-archive.component';


const routes: Routes = [
  {
    path: '',
    component: PortalEventsComponent
  },
  {
    path: 'archive',
    pathMatch: 'full',
    component: EventsArchiveComponent
  },
  {
    path: ':slug',
    loadChildren: () => import('./details-portal-event/details-portal-event.module').then(m => m.DetailsPortalEventModule),
    data: {
      isCacheable: true,
      toolbarMode: ToolbarMode.solid
    },
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PortalEventsRoutingModule { }
